// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"7a65aa35","453":"d2a58751","953":"71b02f3d"}[chunkId] + ".chunk.js";
};